<template>
    <div>
        <div class="title pt-2 required-field">
            <span>{{FORM_LABELS.PURCHASE_ORDER_NUMBER}}</span>
        </div>
        <div class="mb-4 my-2">
            <input
                    class="form-control"
                    name="toBeReturnedPoNumber"
                    v-model.trim="toBeReturnedPoNumber"
                    id="toBeReturnedPoNumber"
                    @blur="onPoNumberEntered"
                    @input="clearMessages"
                    autocomplete="nope"
                    v-validate.continues="{ required: true, min:10, max: 10, regex: /^([0-9]+)$/ }"
                    data-vv-validate-on="input"
            />
            <small-spinner v-if="purchaseOrderDetailsLoading"></small-spinner>
            <div v-if="poDetails&&!poDetails.companyCode" class="mt-1">
              No details found for PO: <span class="font-weight-bold"> {{toBeReturnedPoNumber}}</span>
              <div class="text-danger input-error-text">Please correct the purchase order number.</div>
            </div>
            <show-errors :field-name="FORM_LABELS.PURCHASE_ORDER_NUMBER" :for-item="'toBeReturnedPoNumber'" :min-length="10" :max-length="10" :form-errors="errors" />
        </div>
    </div>
</template>

<script>
import api from "@/api"
import SmallSpinner from "../../SmallSpinner";
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";
import {mapMutations} from "vuex";
import CONSTANTS from "@/store/constants";

export default {
        name: "PurchaseOrderInput",
        components: {SmallSpinner},
        mixins: [PaymentFormsMixin],
        props:['formType','poNumber'],
        inject: ["$validator"],
        data(){
            return{
                purchaseOrderDetailsLoading: false,
                poDetails:null,
                toBeReturnedPoNumber:null
            }
        },
        created(){
            this.toBeReturnedPoNumber = this.poNumber
        },
        methods:{
          ...mapMutations(["setBankDetailsDropdownValues"]),
            clearMessages(){
                this.poDetails = null;
            },
            onPoNumberEntered(){
                if(this.toBeReturnedPoNumber && this.toBeReturnedPoNumber.length <= CONSTANTS.PO_NUMBER_MAX_LENGTH && (
                    this.$validator.errors.items && this.$validator.errors.items.length>0 &&
                    this.$validator.errors.items[0].field && this.$validator.errors.items[0].field!=="poNumber" ||
                    (!this.$validator.errors.items || this.$validator.errors.items.length===0) )){
                    this.purchaseOrderDetailsLoading = true;
                    let respObject = {}
                    respObject.poNumber = this.toBeReturnedPoNumber;
                    api.getPOSupplierDetailsById(respObject.poNumber,this.formType).then(res=>{
                        if(res.data && res.data.data.fetchWebformDetail && res.data.data.fetchWebformDetail.webformResponse){
                            respObject = res.data.data.fetchWebformDetail.webformResponse.invoiceDetail;
                            this.poDetails = respObject
                        }
                        if (res.data && res.data.data.fetchWebformDetail && res.data.data.fetchWebformDetail.webformResponse && res.data.data.fetchWebformDetail.webformResponse.bankDetails){
                          this.setBankDetailsDropdownValues(res.data.data.fetchWebformDetail.webformResponse.bankDetails)
                        }else{
                          this.setBankDetailsDropdownValues([]);
                        }
                      //This method clears out the bankDetails when a new PO-Number is entered when form type = PObased / Adv-PO based.
                      if (this.formType === CONSTANTS.PO_BASED_API_FORM_TYPE){
                        this.clearBankData(this.poBasedPaymentData);
                      }else if (this.formType === CONSTANTS.ADV_PO_BASED_API_FORM_TYPE){
                        this.clearBankData(this.advPOBasedPayment);
                      }
                    }).finally(()=>{
                        this.$emit('onPurchaseOrderEntered',respObject)
                        this.purchaseOrderDetailsLoading = false;
                        
                        // add poNumber validation error based on return of api call
                        let invalid = !(this.poDetails && this.poDetails.companyCode);
                        this.setIsInvalidPoNumber(invalid)

                    })
                }

            },
        }
    }
</script>

<style scoped>

</style>